import React from 'react'
import { Trans } from '@lingui/react'
import { DialogHeader, DialogContent, Grid, GridCol, ReachDialog } from '../../common/ui-kit'
import { TabsAuthStatefull } from '../../common/modules/auth/TabsAuth'
import { i18n } from '../../common/utils/intl'

export const ModalAuth = (props: {
  close: () => void
  showProductRequiresAuthMessage?: boolean
  defaultActiveTabIndex?: number
}) => {
  const { close, showProductRequiresAuthMessage, defaultActiveTabIndex = 0 } = props

  return (
    <ReachDialog id="modal-auth" onDismiss={close}>
      <DialogHeader title={i18n.t`Prihlásenie`} />
      <DialogContent>
        <Grid className="align-items-center">
          {showProductRequiresAuthMessage && (
            <GridCol size="fill">
              <div className="mb">
                <Trans>
                  Pre nákup tohto produktu musíte byť prihlásený. Ak u nás ešte nemáte účet, môžete
                  sa zaregistrovať.
                </Trans>
              </div>
            </GridCol>
          )}
          <GridCol size={10}>
            <TabsAuthStatefull defaultActiveTabIndex={defaultActiveTabIndex} />
          </GridCol>
        </Grid>
      </DialogContent>
    </ReachDialog>
  )
}
